import {
  FooterComponent as FooterComponent_,
  SectionComponent as SectionComponent_,
} from "./interfaces/base";
import { useAppSelector } from "../../store/hooks";
import RenderChildren from "./RenderChildren";
import styled from "@emotion/styled";
import BackgroundVideoComponent from "./BackgroundVideoComponent";
import React from "react";
import {
  getBuilderDomId,
  matchesEditorTarget,
} from "./utilities/componentIdentity";
const Footer = styled("footer")(
  null,
  (props) =>
    function (props: any) {
      return { ...props["data-style"] };
    }
);
export default function FooterComponent({
  id,
  uuid,
  attributes,
  childElements,
  childWebpageComponentRelations,
}: FooterComponent_) {
  const editorId = useAppSelector((state) => state.textEditor?.get("id"));
  const domId = getBuilderDomId({ id, uuid });

  return (
    <Footer
      id={domId || undefined}
      data-style={attributes.styles ?? ""}
      data-component-type="footer"
      className={
        "builder-component relative builder-component__header " +
        (attributes.classes ?? "") +
        (matchesEditorTarget({ id, uuid }, editorId)
          ? " builder-component--active"
          : "")
      }
    >
      <BackgroundVideoComponent componentKey={domId || undefined} />
      <RenderChildren
        key={`${domId || "footer"}-children`}
        childWebpageComponentRelations={childWebpageComponentRelations}
      />
    </Footer>
  );
}
